import React__default, { useEffect } from 'react';
import { Overlay } from './Overlay.es.js';
import { SizeEnum } from '@teko/types/ds';
import { getScrollbarWidth, pixelParse } from '../../helpers/utils.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Modal = (_a) => {
  var _b = _a, {
    show,
    onHide,
    children,
    size = SizeEnum.m,
    backDropStyle,
    parent
  } = _b, props = __objRest(_b, [
    "show",
    "onHide",
    "children",
    "size",
    "backDropStyle",
    "parent"
  ]);
  const parentElement = typeof document !== "undefined" ? parent || document.body : null;
  useEffect(() => {
    if (!parentElement || !show) {
      return;
    }
    parentElement.style.overflow = "hidden";
    parentElement.style.paddingRight = `${getScrollbarWidth()}px`;
    return () => {
      parentElement.style.overflow = "unset";
      parentElement.style.paddingRight = "unset";
    };
  }, [show]);
  if (!show)
    return null;
  return /* @__PURE__ */ React__default.createElement(Overlay, {
    parent: parentElement || void 0,
    show,
    onEscPressed: onHide
  }, /* @__PURE__ */ React__default.createElement(Backdrop, {
    onClick: onHide,
    style: backDropStyle
  }), /* @__PURE__ */ React__default.createElement(ModalContent, __spreadValues({
    size
  }, props), children));
};
const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
  [SizeEnum.s]: "400px",
  [SizeEnum.m]: "700px",
  [SizeEnum.l]: "960px"
};
const ModalContent = styled.div(({
  theme,
  size,
  width,
  maxHeight,
  borderRadius,
  backgroundColor
}) => `
    background-color: ${backgroundColor || (theme == null ? void 0 : theme.colors.white)};
    display: flex;
    flex-direction: column;
    width: ${width !== void 0 ? pixelParse(width) : sizeMaps[size || "m"]};
    border-radius: ${borderRadius || (theme == null ? void 0 : theme.borderRadius.m)};
    max-height: ${maxHeight || "90%"};
    z-index: 1060;
    position: relative;
    overflow-y: auto;
  `);

export { Modal };
